export default __webpack_public_path__ + "static/media/mappng.17659604.png";